import React from 'react';

const TablePaginationActions = () => {
    return null; // Bu bileşen, sayfa geçiş butonlarını gizlemek için boş döndürür
};

export default TablePaginationActions;
